import { useEffect, useState, type FC } from 'react';
import { Picture } from '@ui';
import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import icons from '@icons';

const {
  checkmark: { white: checkmarkWhiteOutlined }
} = icons.Outline;

interface RectangleToggleWithLabelProps {
  onChange: () => void;
  label: string;
  isChecked: boolean;
  disabled?: boolean;
  className?: string;
}

const RectangleToggleWithLabel: FC<RectangleToggleWithLabelProps> = ({
  onChange,
  isChecked,
  label,
  disabled,
  className
}) => {
  const [localChecked, setLocalChecked] = useState(isChecked);

  useEffect(() => {
    if (!disabled) {
      setLocalChecked(isChecked);
    }
  }, [isChecked, disabled]);

  const handleClick = (): void => {
    if (disabled) return;
    setLocalChecked(prev => !prev);
    onChange();
  };

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={twcls(
        'flex items-center gap-3 w-full py-1.5 cursor-pointer text-left disabled:text-[var(--dark-grey)] bg-transparent',
        className
      )}
    >
      <div
        className={twcls(
          `flex items-center justify-center w-5 h-5 rounded border border-solid transition-colors bg-white border-[var(--dark-grey)]
          `,
          localChecked && 'bg-[#B32442] border-[#B32442]',
          disabled && 'bg-[#C2C2C2] border-[var(--dark-grey)]'
        )}
      >
        {localChecked && (
          <Picture icon={checkmarkWhiteOutlined} width={14} height={14} />
        )}
      </div>

      <span className='text-base'>{label}</span>
    </button>
  );
};

export default observer(RectangleToggleWithLabel);
